export const HideShowIcon = ({ width = 10, height = 6, color = "#212529", ...props }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M-3.65157e-08 6L5 0L10 6L-3.65157e-08 6Z" fill={color} />
        </svg>
    );
};
